
import {t} from "i18next";
import {Modal} from "antd";
import {deleteShiftWorkApi} from "../../../../../../api/hrm/timekeeping/time-sheet/shift-schedule";
import {store} from "../../../../../../redux/store/store";
import {onReloadData} from "../../../../../../redux/actions/layout/interaction/action";
import {deleteProcessGateWay} from "../../../../../../api/workplace/process/work-process/process-config";
import {useSelector} from "react-redux";
import {APP_CODE, APP_CODE_SALARY} from "./Constant";
import {deleteSalary} from "../../../../../../api/hrm/wage/salary";

export const handleOnDelete = async (id, classPk, moduleCode, appCode, onAfterSuccess,decisionNo) => {
    const onDelete = async (id) => {
            switch (appCode) {
                case APP_CODE :
                    return await deleteShiftWorkApi( id).then(() => {
                        store.dispatch(onReloadData(true))
                    }).catch(() => {
                    });
                case APP_CODE_SALARY :
                    return await deleteSalary( id).then(() => {
                        store.dispatch(onReloadData(true))
                    }).catch(() => {
                    });
                default :
                    break;
            }


    }

    Modal.confirm({
        title: appCode === APP_CODE ? t("tnp.components.shiftAssignment.button.titleDelete") : t("tnp.components.shiftAssignment.button.titleSalaryDelete"),
        content:
            <div>
                {t("tnp.button.confirmRemove")}
                <span className={"font-bold"}>{decisionNo}</span>
                {t("tnp.button.no")}
            </div>,
        onOk: async () => {
            return await deleteProcessGateWay({moduleCode, appCode, classPk}).then(() => {
                return onDelete(id).then(r => {
                    onAfterSuccess && onAfterSuccess()
                    // store.dispatch(onReloadData(true))
                }).catch(() => {
                })
            }).catch(() => {
            })
        },
        cancelText: t("common.no"),
        okText: t("common.delete"),
        maskClosable: true,
        icon: <></>
    })
};